import { getLookupList } from "../utils/apiUtils"
import { ENTITY_NAME_WRITING_STYLE, ENTITY_NAME_WRITING_STYLE_TYPE } from "./dbConstants";

export const getListOptions = async() => {
  return getLookupList(ENTITY_NAME_WRITING_STYLE)
}

export const getTypeListOptions = async() => {
  return getLookupList(ENTITY_NAME_WRITING_STYLE_TYPE)
}
